import styles from './StatsBar.module.scss';
import PropTypes from 'prop-types';
import { StatBarDisplay } from 'types/types';
import { checkNullReturnZero } from 'utils/common';

const MainStats = (props) => {
    const { marketStat, teamStat, rmStat } = props;
    return (
        <>
            {/* Market */}
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(marketStat)}
                    </div>
                </div>
                <div className={styles.description}>
                    {StatBarDisplay.MARKET}
                </div>
            </div>

            {/* Team */}
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(teamStat)}
                    </div>
                </div>
                <div className={styles.description}>{StatBarDisplay.TEAM}</div>
            </div>

            {/* RM */}
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(rmStat)}
                    </div>
                </div>
                <div className={styles.description}>RM</div>
            </div>
        </>
    );
};

MainStats.propTypes = {
    marketStat: PropTypes.number,
    teamStat: PropTypes.number,
    rmStat: PropTypes.number
};
export default MainStats;
